import { Download, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';

const STORES = [
  {
    id: 'chrome',
    storeUrl: process.env.REACT_APP_CHROME_STORE_URL,
    zip: '/lifeautofill-extension.zip',
    storeLabel: 'ADD TO CHROME',
    zipLabel: 'DOWNLOAD FOR CHROME',
    primary: true,
  },
  {
    id: 'firefox',
    storeUrl: process.env.REACT_APP_FIREFOX_STORE_URL,
    zip: '/lifeautofill-firefox.zip',
    storeLabel: 'ADD TO FIREFOX',
    zipLabel: 'DOWNLOAD FOR FIREFOX',
  },
];

export const anyStoreLive = STORES.some((s) => s.storeUrl);

export const StoreButtons = () => (
  <>
    {STORES.map((s) => {
      const live = Boolean(s.storeUrl);
      return (
        <a
          key={s.id}
          href={live ? s.storeUrl : s.zip}
          {...(live ? { target: '_blank', rel: 'noopener noreferrer' } : { download: true })}
          data-testid={live ? `add-to-${s.id}-btn` : s.id === 'chrome' ? 'download-extension-btn' : 'download-firefox-btn'}
        >
          <Button size="lg" variant={s.primary ? 'default' : 'outline'} className={`uppercase tracking-widest ${s.primary ? 'brutalist-shadow-sm' : ''}`}>
            {live ? <ExternalLink className="w-4 h-4 mr-2" /> : <Download className="w-4 h-4 mr-2" />}
            {live ? s.storeLabel : s.zipLabel}
          </Button>
        </a>
      );
    })}
  </>
);

export const ManualInstallLinks = () =>
  anyStoreLive ? (
    <p className="text-xs text-muted-foreground mt-2" data-testid="manual-install-links">
      Manual install:{' '}
      <a href={STORES[0].zip} download className="underline hover:text-foreground">Chrome .zip</a> ·{' '}
      <a href={STORES[1].zip} download className="underline hover:text-foreground">Firefox .zip</a>
    </p>
  ) : null;
